import { MESSAGING_CLIENT_ELEMENT_ID } from '../constants/index';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import styles from './ember-messaging-client.module.scss';
import svgJar from 'ember-svg-jar/helpers/svg-jar';

export default class EmberMessagingClient extends Component {
  @service messaging;
  @service messagingInterface;
  @service messagingNavigation;

  get isLoading() {
    return (
      this.messaging.loadApp.isRunning || this.messagingInterface.isResolvingExternalConversation
    );
  }

  get legacyClasses() {
    const classes = [];

    if (!this.messaging.groupMessagingEnabled) {
      classes.push('emc-gm-disabled');
    }

    return classes.join(' ');
  }

  <template>
    <div
      id={{MESSAGING_CLIENT_ELEMENT_ID}}
      class="{{styles.component}} messaging-client {{this.legacyClasses}}"
      data-test-ember-messaging-client
      ...attributes
    >
      {{#if this.isLoading}}
        <div class="spinner" data-test-loading-spinner>
          {{svgJar "messaging-spinner"}}
        </div>
      {{else if this.messagingNavigation.currentRoute}}
        {{component
          this.messagingNavigation.currentRoute.component
          handler=this.messagingNavigation.currentRoute.handler
        }}
      {{/if}}
    </div>
  </template>
}
